import { render, staticRenderFns } from "./AttendanceCorrections.vue?vue&type=template&id=6a0291a4"
import script from "./AttendanceCorrections.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports